// Waggy Waggy自定义开始：免费配送公告货币转换
(function () {
  const baseUSD = 50;
  const originalPattern = /(Free Shipping(?:\s+on)?\s+)\$50(?=\+)/gi;

  function updateFreeShippingMessage() {
    const currencyData = window.Shopify && window.Shopify.currency;
    if (!currencyData) return;

    const currency = currencyData.active || 'USD';
    const rate = Number(currencyData.rate);
    if (!Number.isFinite(rate) || rate <= 0) return;

    const localAmount = Math.ceil(baseUSD * rate);
    const formattedAmount = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      maximumFractionDigits: 0
    }).format(localAmount);

    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT
    );

    let textNode;
    while ((textNode = walker.nextNode())) {
      textNode.nodeValue = textNode.nodeValue.replace(
        originalPattern,
        (_match, beforeAmount) => beforeAmount + formattedAmount
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateFreeShippingMessage);
  } else {
    updateFreeShippingMessage();
  }

  document.addEventListener('shopify:section:load', updateFreeShippingMessage);
})();
// Waggy Waggy自定义结束